// extracted by mini-css-extract-plugin
module.exports = {"v1f85mj1":"v1f85mj1","tfhuqru":"tfhuqru"};